module.exports = __webpack_public_path__ + "static/library-08289311e1f264c9d96f9b11dadb918b.mp4";